import { Tooltip, TooltipAnchor, TooltipArrow, TooltipProvider } from '@ariakit/react';
import cx from 'classnames';

import { Button, type ButtonProps, ButtonSize, ButtonVariant } from '~/ui/components/button';
import typographyStyles from '~/ui/styles/typography.module.scss';

import styles from './action.module.scss';

export interface BaseActionProps extends Omit<ButtonProps, 'size' | 'variant'> {
  // All buttons should have tooltips except the main toggle button. We want to be very explicit
  //  about bypassing these.
  tooltip: string | null;
}

export function BaseAction({ tooltip, className, ...props }: BaseActionProps) {
  const button = (
    <Button
      {...props}
      size={ButtonSize.ICON}
      variant={ButtonVariant.PRIMARY}
      className={cx(styles.action, className)}
    />
  );

  if (!tooltip) {
    return button;
  }

  return (
    <TooltipProvider>
      <TooltipAnchor render={button} />
      <Tooltip className={cx(typographyStyles.bodySmall, styles.tooltip)}>
        {tooltip}
        <TooltipArrow />
      </Tooltip>
    </TooltipProvider>
  );
}
